import React from 'react';
import Auth from './Auth';
import { User } from '../../services/authService';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAuthChange: (user: User | null, token?: string) => void;
  title?: string;
}

const AuthModal: React.FC<AuthModalProps> = ({ 
  isOpen, 
  onClose, 
  onAuthChange, 
  title = "Welcome to LifeOS" 
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content auth-modal">
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-btn" onClick={() => {
            console.log('🔍 Modal close button clicked');
            onClose();
          }}>×</button>
        </div>
        <Auth onAuthChange={onAuthChange} />
      </div>
    </div>
  );
};

export default AuthModal;
